import React from 'react';

import styles from './TopPartOfCalendar.module.scss';

type TopPartOfCalendarProps = {
	value: string;
	x1Line: number;
	y1Line: number;
	y2Line: number;
	xText: number;
	yText: number;
};

const TopPartOfCalendar: React.FC<TopPartOfCalendarProps> = ({
	value,
	x1Line,
	y1Line,
	y2Line,
	xText,
	yText,
}) => {
	return (
		<g className='calendarTop'>
			<line
				key={value + 'line'}
				className={styles.calendarTopTick}
				x1={x1Line}
				x2={x1Line}
				y1={y1Line}
				y2={y2Line}
			/>
			<text
				key={value + 'text'}
				className={styles.calendarTopText}
				x={xText}
				y={yText}
			>
				{value}
			</text>
		</g>
	);
};

export default TopPartOfCalendar;
